module.exports = __webpack_public_path__ + "img/cliGloss1.bbf1fd81.jpg";